module.exports = __webpack_public_path__ + "img/title2.cabb2878.png";